import { TReduxActions } from '../../../types/redux';
import { EConsActionTypes } from '../../../actions/newReview';
import { TConsRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: null,
};

export function consReviewReducer(state: TConsRating = defaultValue, { type, payload }: TReduxActions): TConsRating {
  if (type === EConsActionTypes.Set) {
    return {
      value: payload as string,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
